import React from 'react';
import { Image } from '../../layout/Image';

type LoyaltyCtaProps = {
  onClick: () => void;
};

export const LoyaltyCta: React.FC<LoyaltyCtaProps> = ({ onClick }) => {
  const homeLink = process?.env?.NEXT_PUBLIC_HOME_LINK;

  if (!homeLink) return null;

  return (
    <a
      href={`${homeLink}/basket?grcm=1`}
      className="items-left bg-background-primary flex h-[72px] w-full flex-row justify-between overflow-hidden rounded-lg"
      onClick={onClick}
    >
      <span className="text-md/5 min-w-[246px] content-center p-4 text-white">
        Add Your Free Personalised Greetings Card&nbsp;
        <span className="cursor-pointer font-bold underline">here</span>.
      </span>
      <Image
        src="https://images.prismic.io/virginexperiencedays/ZyNJs68jQArT0DPK_svgviewer-png-output-4-.png?auto=format,compress"
        alt="Greetings Cards"
        fill
        imageClassName="object-left"
      />
    </a>
  );
};
